import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { TopSection } from "./About";
import Wave from "../components/Wave2";
import axios from "axios";

const CategoryCard = ({ category, isMobile, onClick }) => {
  const cardStyles = {
    width: isMobile ? "45vw" : "30vw",
    aspectRatio: "3 / 4",
    border: "2px dashed #f87171",
    borderRadius: "40px",
    padding: isMobile ? "6px" : "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    boxSizing: "border-box",
    backgroundColor: "#fff",
    cursor: "pointer",
  };

  const headerStyles = {
    margin: "12px 0 8px 0",
    fontSize: isMobile ? "14px" : "24px",
    textAlign: "center",
  };

  const paragraphStyles = {
    fontSize: isMobile ? "12px" : "18px",
    color: "#555",
    fontFamily: "Outfit",
    textAlign: "center",
  };

  const buttonStyles = {
    margin: "20px auto",
    fontSize: isMobile ? "12px" : "16px",
    width: isMobile ? "90%" : "auto",
    padding: isMobile ? "8px 16px" : "10px 20px",
    border: "none",
    cursor: "pointer",
  };

  return (
    <div style={cardStyles} onClick={onClick}>
      <div
        style={{
          height: "60%",
          border: "1px dashed #00000040",
          borderRadius: "30px",
          background: category.image?.src ? `url(${category.image.src}) no-repeat center center` : "#f0f0f0",
          backgroundSize: "cover",
        }}
      />
      <div>
        <h2 style={headerStyles}>{category.name}</h2>
        {category.description && <p style={paragraphStyles}>{category.description}</p>}
      </div>
      <button className="btn" style={buttonStyles}>
        View Services
      </button>
    </div>
  );
};

const Service = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [categories, setCategories] = useState([]);
  const [heading, setHeading] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setLoading(true);
    
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/service-categories`)
      .then((res) => setCategories(res.data || []))
      .catch(() => setCategories([]));

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/services`)
      .then((res) => {
        if (res.data) {
          setHeading(res.data.heading || "");
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleCategoryClick = (categoryId) => {
    navigate(`/category/${categoryId}`);
  };

  return (
    <>
      <TopSection heading={"Our Services"}>
        <h2 style={{ fontSize: isMobile ? "20px" : "40px", color: '#DF2126' }}>{heading}</h2>
      </TopSection>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "10px",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {loading ? (
          <div>Loading...</div>
        ) : categories.length === 0 ? (
          <div>No service categories available.</div>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(3, 1fr)",
              gap: isMobile ? "12px" : "24px",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              padding: "20px 0",
            }}
          >
            {categories.map((category) => (
              <CategoryCard
                key={category._id}
                category={category}
                isMobile={isMobile}
                onClick={() => handleCategoryClick(category._id)}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default Service;